import React, { Component } from 'react';
import { ContentGroup } from 'ui';
import Select from 'components/shared/select';
import ContentCard from '../../shared/LearnContentCard';

/*::
type AssignmentGroupProps = {
  title: string,
  assignments: Array<Object>,
  sortable: boolean,
  defaultSortOption: SortOption,
  sortOptions: {
    [SortOptionValue]: SortOption
  },
}

type SortOptionValue = string;

type SortOption = {
  label: string,
  sort: (a: any, b: any) => number,
}
*/

class AssignmentGroup extends Component {
  constructor(props /*: AssignmentGroupProps */) {
    super(props);
    this.state = { selectedSortOption: props.defaultSortOption };
    this.onSortChange = this.onSortChange.bind(this);
  }

  onSortChange(e) {
    this.setState({ selectedSortOption: e.target.value });
  }

  getAssignments() {
    const { assignments, sortable, sortOptions } = this.props;
    if (sortable) {
      const { selectedSortOption } = this.state;
      const { sort: compareFn } = sortOptions[selectedSortOption];
      return assignments.sort(compareFn);
    }
    return assignments;
  }

  render() {
    const { selectedSortOption } = this.state;
    const { sortOptions } = this.props;
    return (
      <div className="mb-16">
        <ContentGroup
          className="LearnContentGroup"
          items={this.getAssignments()}
          title={this.props.title}
        >
          {this.props.sortable && (
            <ContentGroup.Action>
              <div>
                <span className="mr-8">{t('content.sort.prompt')}</span>
                <Select
                  onChange={this.onSortChange}
                  value={selectedSortOption}
                  ariaLabel={t('content.sort.aria_label_sorting_options')}
                >
                  {Object.entries(sortOptions).map(([value, option]) => (
                    <option key={value} value={value}>
                      {option.label}
                    </option>
                  ))}
                </Select>
              </div>
            </ContentGroup.Action>
          )}
          <ContentGroup.Items
            render={assignment => (
              <ContentCard
                key={`${assignment.id}.${assignment.type}`}
                {...assignment}
              />
            )}
          />
        </ContentGroup>
      </div>
    );
  }
}

export default AssignmentGroup;
